import React from "react";
import OrchestraMembersDisplay from "../components/OrchestraMembersDisplay/OrchestraMembersDisplay";
import styles from "./page.default.module.css";
import { useTranslation } from "react-i18next";

const Musicians: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.pageSection}>
      <div className={styles.container}>
        <div className={styles.heading}>
          <h1 className={styles.title}>{t("musicians.title")}</h1>
          <p className={styles.description}>{t("musicians.description")}</p>
        </div>
        <OrchestraMembersDisplay />
      </div>
    </section>
  );
};

export default Musicians;
